import {
  FETCH_COIN_TASKS_REQUEST,
  FETCH_COIN_TASKS_SUCCESS,
  FETCH_COIN_TASKS_FAILURE,
} from '../types/coinTaskTypes';
import axiosInstance from '../../utils/setupAxios';

export const EMPTY_COIN_TASK_FILTER_OPTIONS = {
  app_versions: [],
  country_codes: [],
  os_list: [],
  os_versions: [],
};

export const normalizeCoinTaskFilterOptions = (data) => {
  if (!data || typeof data !== 'object') {
    return { ...EMPTY_COIN_TASK_FILTER_OPTIONS };
  }

  const toStringList = (value) => {
    if (!Array.isArray(value)) return [];
    return value
      .map((item) => (item == null ? '' : String(item).trim()))
      .filter((item) => item !== '');
  };

  return {
    app_versions: toStringList(data.app_versions),
    country_codes: toStringList(data.country_codes),
    os_list: toStringList(data.os_list),
    os_versions: toStringList(data.os_versions),
  };
};

export const fetchCoinTaskFilters = async () => {
  const response = await axiosInstance.get('/coins/tasks/filters');
  if (response.data?.success) {
    return normalizeCoinTaskFilterOptions(response.data.data);
  }
  return { ...EMPTY_COIN_TASK_FILTER_OPTIONS };
};

export const fetchCoinTasks = (params = {}) => async (dispatch) => {
  dispatch({ type: FETCH_COIN_TASKS_REQUEST });
  try {
    const response = await axiosInstance.get('/coins/tasks', { params });
    if (response.data.success) {
      dispatch({ type: FETCH_COIN_TASKS_SUCCESS, payload: response.data.data });
    } else {
      dispatch({ type: FETCH_COIN_TASKS_FAILURE, payload: response.data.message || 'Failed to fetch tasks' });
    }
  } catch (error) {
    dispatch({ type: FETCH_COIN_TASKS_FAILURE, payload: error.response?.data?.message || 'Failed to fetch tasks' });
  }
};

export const deleteCoinTask = async (taskId) => {
  const response = await axiosInstance.delete(`/coins/tasks/${taskId}`);
  return response.data?.success === true;
};

export const deleteCoinTasks = async (taskIds) => {
  const response = await axiosInstance.post('/coins/tasks/bulk-delete', { task_ids: taskIds });
  return response.data;
};
